import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';
import endpoints from '../../../config/endpoints';

import http from '../../shared/http';
import intl from '../../shared/intl';
import checkPermissions from '../../shared/check-permissions';

import cloneDeep from 'lodash/cloneDeep';

import createForm from '../components/form/large';

const form = createForm({
	namespace: 'newsEdit',
	stateNodeName: 'form'
});

// action types
const FETCH_DATA_SUCCESS = 'news-edit/fetch-data-success';
const FETCH_DATA_ERROR = 'news-edit/fetch-data-error';

const TOGGLE_PROGRESS_BAR = 'news-edit/toggle-progress-bar';

// permissions
export const allowedPermissions = {
	view: 'news_list',
	edit: 'news_create'
};

// initial state
const initialState = {
	data: null,
	form: form.initialState,
	defaultLanguage: 'en',
	showProgressBar: false,
	error: false
};

// actions
export const actions = Object.assign(
	{
		fetchData: props => (dispatch, getState) => {
			const id = props && props.params && props.params.id;
			if (!id) {
				return dispatch({ type: FETCH_DATA_SUCCESS, payload: {} });
			}
			return http({
				url: `${endpoints.NEWS.BASE}/${id}`,
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
			})(dispatch);
		},

		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		})
	},
	form.actions
);

const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			return initialState;
		},
		[FETCH_DATA_SUCCESS]: (state, action) => {
			const data = action.payload && action.payload.data;
			return {
				...state,
				data: data && mapOffersData(data),
				showProgressBar: false,
				error: false
			};
		},
		[FETCH_DATA_ERROR]: (state, action) => ({ ...state, error: true, showProgressBar: false }),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar })
	},
	form.reducers
);

// reducers
export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.newsEdit.data,
	getFormData: form.selectors.getFormData,
	getFormTabLangs: state => getTabLangs(state),
	getProgressBar: state => state.newsEdit.showProgressBar,
	getIntl: state => intl(state),
	getCan: state => checkPermissions(state, allowedPermissions),
	getError: state => state.newsEdit.error
};

const getTabLangs = state => {
	const { defaultLanguage, form: { currentLanguage }, data } = state.newsEdit;
	let langs = data && data.id
		? state.root.lists.languages
		: state.root.lists.languages && state.root.lists.languages.filter(lang => lang.id === 'en');

	return langs.map(lang => ({
		...lang,
		isSelected: true,
		isActive: lang.id === currentLanguage,
		isDefault: lang.id === defaultLanguage
	}));
};

const mapOffersData = data => {
	return { ...data, news_offers: data.news_offers && data.news_offers.map(o => ({ value: o.id, label: o.title })) };
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/news/edit/index.js